export enum EditMode {
  /** Add a new record */
  Add = "Add",
  /** Edit an existing record */
  Edit = "Edit",
  /** Read only */
  ReadOnly = "ReadOnly",
  /** Import new records */
  Import = "Import",
}
